import React from 'react';
import StatsIcon from 'cccisd-icons/stats-bars2';
import { Link } from 'cccisd-react-router';
// gets the score from the last flow response taken

const ViewReports = () => {
    const params = window.location.pathname.split('/');
    return () => {
        return (
            <div className="text-center">
                <Link className="btn btn-primary" to={`/${params[1]}/${params[2]}/reportCenter`}>
                    <StatsIcon spaceRight /> View Reports
                </Link>
            </div>
        );
    };
};
export default ViewReports;
